import React from "react";
import Section from "../Section";
import SectionHeader from "../SectionHeader";

function StorePage(props) {

    function actionOnClick(e) {
        e.preventDefault()
        if (props.onAddNew) {
            props.onAddNew()
        }
        // history.push(`${match.url}/create`)
    }

    return (
        <Section
        textColor="dark"
        size="md"
        bgImage=""
        bgImageOpacity={0}
        className="container"
        >
            <SectionHeader
            // title={"Live Experiences"}
            // subtitle={"Here's a list of all your experiences, appointments, and digital products"}
            title={props.title}
            subtitle={props.subtitle}
            size={2}
            spaced={true}
            actionTitle={"Add New"}
            actionOnClick={actionOnClick}
            ></SectionHeader>
            {props.children}
        </Section>
    );
}

export default StorePage;